import React, { useEffect, useState } from "react";
import s from "../MatrizControlED.module.css";

//assets
import gamesService from "../../../../api/games/GamesService";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "dayjs/locale/es";
import "dayjs/locale/pt";

//Material Ui
import FormControl from "@mui/material/FormControl"
import Grid from "@mui/material/Grid"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import FormHelperText from "@mui/material/FormHelperText"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"
import CircularProgress from "@mui/material/CircularProgress"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// ========================= | FILTROS MATRIZ CONTROLED | ======================

const FiltrosMatrizControlED = ({
  handleConsult,
  setItems,
  getAllData,
  filters,
  setFilters,
  setLoadingFilters,
  games,
  setGames,
  setTotalResults,
}) => {
  const { t } = useTranslation();

  const { language } = useSelector((state) => state.local);
  const organization = useSelector((state) => state.gamma.activeOrganization);

  const [raffles, setRaffles] = useState([]);
  const [loadingSeries, setLoadingSeries] = useState(false);

  const filtrarRepetidos = (array, propiedad) => {
    return array.filter((objeto, index) => {
      const primerIndice = array.findIndex(
        (elemento) => elemento[propiedad] === objeto[propiedad],
      );
      return index === primerIndice;
    });
  };

  const handleCheck = (value, item) => {
    if (value) {
      setFilters((prev) => ({ ...prev, series: [...prev.series, item.serie] }));
    } else {
      let filter = filters.series.filter((i) => i !== item.serie);
      setFilters((prev) => ({ ...prev, series: [...filter] }));
    }
  };

  useEffect(() => {
    if (games !== null) {
      setRaffles([]);
      setLoadingSeries(true);
      let game = games.filter(
        (item) => {
          return item?.modality?.game?.id === filters.gameId
        }
      );
      // game = game.length > 0 ? game[0] : null;
      console.log(game)
      gamesService
        .getRaffle(filters.gameId, game?.modality?.mode?.id, 1, 10000)
        .then((res) => {
          setRaffles(filtrarRepetidos(res.content, "serie"));
          setFilters((prev) => ({
            ...prev,
            series:
              filtrarRepetidos(res.content, "serie")
                ?.map((item) => item?.serie)
                ?.filter((item) => item !== null) || [],
          }));
        })
        .then(() => setLoadingSeries(false))
        .catch(() => setLoadingSeries(false));
    }

  }, [filters.gameId, games, setFilters]);

  useEffect(() => {
    if (!games.length) {
      setLoadingFilters(true);
      gamesService.getAllGames().then((res) => {
        setGames(res.content);
        setLoadingFilters(false);
      });
    }
  }, []);

  return (
    <Grid item container xs={11} className={s.filters}>
      <Grid item xs={11} md={11} lg={3.5} className={[s.item, s.init1]}>
        <FormControl sx={{ width: "90%" }}>
          <InputLabel
            id={"select-label"}
          >{`${t("type")} de ${t("game")}`}</InputLabel>
          <Select
            labelId="select-label"
            label={`${t("type")} de ${t("game")}`}
            value={filters.type}
            onChange={(e) => {
              setItems([]);
              setTotalResults(0);
              setFilters((prev) => ({
                ...prev,
                type: e.target.value,
                gameId: 0,
                drawDate: null,
                createDate: null,
                series: [],
                agencyFrom: "",
                agencyTo: "",
              }));
            }}
          >
            <MenuItem value={0}>{t("select")}</MenuItem>
            <MenuItem value={1}>{t("preprinted")}</MenuItem>
            <MenuItem value={2}>{t("instant")}</MenuItem>
          </Select>
          <FormHelperText>* {t("obligatoryField")}</FormHelperText>
        </FormControl>
      </Grid>

      {filters?.type ? (
        <Grid item xs={11} md={11} lg={3.5} className={[s.item, s.init2]}>
          <FormControl sx={{ width: "90%" }}>
            <InputLabel id={"selectgame-label"}>{`${t("game")}`}</InputLabel>
            <Select
              labelId="selectgame-label"
              label={`${t("game")}`}
              value={filters.gameId}
              onChange={(e) =>
                setFilters((prev) => ({
                  ...prev,
                  gameId: e.target.value,
                  series: [],
                }))
              }
            >
              <MenuItem value={0}>{t("select")}</MenuItem>
              {games
                .filter((game, i) => game?.modality?.mode?.id === filters.type)
                .map((game, i) => (
                  <MenuItem key={i} value={game?.modality?.game?.id}>
                    {game?.modality?.game?.name}
                  </MenuItem>
                ))}
            </Select>
            <FormHelperText>* {t("obligatoryField")}</FormHelperText>
          </FormControl>
        </Grid>
      ) : (
        <Grid item xs={0} md={11} lg={3.5} />
      )}

      {filters?.gameId ? (
        filters?.type === 1 ? (
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={language}
          >
            <Grid item xs={11} md={11} lg={3.5} className={[s.item, s.init2]}>
              <DatePicker
                label={t("drawDate")}
                inputFormat="DD/MM/YYYY"
                value={filters?.drawDate}
                onChange={(v) =>
                  setFilters((prev) => ({ ...prev, drawDate: v }))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    helperText={`* ${t("obligatoryField")}`}
                    sx={{ width: "90%" }}
                  />
                )}
              />
            </Grid>
          </LocalizationProvider>
        ) : (
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={language}
          >
            <Grid item xs={11} md={11} lg={3.5} className={[s.item, s.init2]}>
              <DatePicker
                label={t("dischargeDate")}
                inputFormat="DD/MM/YYYY"
                value={filters?.createDate}
                onChange={(v) =>
                  setFilters((prev) => ({ ...prev, createDate: v }))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    helperText={`* ${t("obligatoryField")}`}
                    sx={{ width: "90%" }}
                  />
                )}
              />
            </Grid>
          </LocalizationProvider>
        )
      ) : (
        <Grid item xs={11} md={11} lg={3.5} />
      )}

      <Grid item xs={11} md={11} lg={3.5} className={[s.item, s.init1]}>
        <TextField
          label={`${t("agency")} ${t("from")}`}
          value={filters.agencyFrom}
          sx={{ width: "90%" }}
          helperText={`${t("onlyNumbers")}`}
          onChange={(e) => {
            if (!isNaN(e.target.value) && Number(e.target.value) >= 0) {
              setFilters({
                ...filters,
                agencyFrom: Number(e.target.value) || null,
              });
            }
          }}
          onKeyDown={(e) => {
            if (e?.key === "-" || e?.key === "+") {
              e.preventDefault();
            }
          }}
        />
      </Grid>

      <Grid item xs={11} md={11} lg={3.5} className={[s.item, s.init1]}>
        <TextField
          label={`${t("agency")} ${t("to")}`}
          value={filters.agencyTo}
          sx={{ width: "90%" }}
          helperText={`${t("onlyNumbers")}`}
          onChange={(e) => {
            if (!isNaN(e.target.value) && Number(e.target.value) >= 0) {
              setFilters({
                ...filters,
                agencyTo: Number(e.target.value) || null,
              });
            }
          }}
          onKeyDown={(e) => {
            if (e?.key === "-" || e?.key === "+") {
              e.preventDefault();
            }
          }}
        />
      </Grid>

      {filters.type === 2 ? (
        <Grid item container xs={11} sx={{ mb: 3 }}>
          <Grid item xs={12}>
            <p
              style={{
                margin: 0,
                fontWeight: 300,
                marginBottom: "10px",
                fontSize: "1.3rem",
              }}
            >
              {t("series")}
            </p>
          </Grid>
          {loadingSeries ? (
            <CircularProgress size="2rem" />
          ) : raffles.length ? (
            <Grid item xs={12}>
              {raffles.map((item, i) => (
                <React.Fragment key={i}>
                  {" "}
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={filters?.series.includes(item.serie)}
                        onChange={(e, v) => handleCheck(v, item)}
                      />
                    }
                    label={item.serie}
                  />{" "}
                </React.Fragment>
              ))}
            </Grid>
          ) : (
            t("noResults")
          )}
        </Grid>
      ) : null}

      <Grid item xs={11} md={11} lg={11} className={[s.item, s.init2]}>
        <Button
          variant="contained"
          onClick={() => {
            handleConsult();
            getAllData();
          }}
          disabled={
            !filters.type ||
            !filters.gameId ||
            (!filters.drawDate && !filters.createDate) ||
            (filters.type === 2 && !filters?.series?.length)
          }
          sx={{ mb: 3 }}
        >
          {t("consult")}
        </Button>
      </Grid>
    </Grid>
  );
};

export default FiltrosMatrizControlED;
